export interface SiteCategory {
  id: string;
  name: string;
  short: string;
  icon: string;
  tagline: string;
  desc: string;
  intro: string;
}

export interface SiteItem {
  id: string;
  name: string;
  url: string;
  category: string;
  desc: string;
  tags: string[];
  heat: number;
  score: number;
  hot: boolean;
  updated: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteCategories: SiteCategory[] = [
  {
    id: 'hot',
    name: '热点爆料',
    short: '热点',
    icon: 'ri-fire-line',
    tagline: '全网热议 · 实时聚合',
    desc: '多家平台公开热榜与舆情动态归集，按事件脉络整理。',
    intro:
      '热点分区收录的是「正在被公开讨论」的内容入口。我们把各平台公开的热榜、话题页与事件时间线集中放在一起，方便你一次看清一件事的来龙去脉，而不是在十几个 App 之间来回跳转。这里的排序只反映公开热度，不代表我们对事件本身的判断。',
  },
  {
    id: 'ent',
    name: '娱乐爆料',
    short: '娱乐',
    icon: 'ri-movie-2-line',
    tagline: '影视综艺 · 动态追踪',
    desc: '剧集定档、综艺排播与演艺公开动态的集中整理。',
    intro:
      '娱乐分区关注影视、综艺与演艺领域的公开信息。我们只整理有明确公开来源的内容，比如官方排播表、片方公告、平台上线信息，不收录无凭据的推测。如果你只想快速知道「最近有什么可看」，从这里挑两个站点就够了。',
  },
  {
    id: 'finance',
    name: '财经揭秘',
    short: '财经',
    icon: 'ri-line-chart-line',
    tagline: '财报解读 · 资本动向',
    desc: '公开财报、融资并购与市场资讯的归集整理。',
    intro:
      '财经分区面向想了解公司经营与资本动向的读者。这里收录的站点大多以公开披露信息为基础，把财报科目、公告要点和融资进展讲得更通俗。内容仅作信息参考，不构成任何投资建议。',
  },
  {
    id: 'tech',
    name: '科技内幕',
    short: '科技',
    icon: 'ri-cpu-line',
    tagline: '数码新品 · 行业前沿',
    desc: '新品发布、实测数据与技术方向的公开信息汇总。',
    intro:
      '科技分区把发布会、实测数据与行业进展放在一处。相比参数罗列，这里更强调可验证的信息：第三方实测、系统更新日志、开发者公开文档。想了解某个产品是否值得关注，可以对照着看几家再下判断。',
  },
  {
    id: 'rights',
    name: '消费维权',
    short: '维权',
    icon: 'ri-shield-check-line',
    tagline: '投诉案例 · 避坑参考',
    desc: '消费纠纷案例、售后进展与维权流程的整理。',
    intro:
      '消费维权分区收录公开的投诉案例与处理进展，也整理了常见的营销话术和合同陷阱。这里的内容意在帮你提前识别风险、知道遇到问题时该走什么流程，遇到具体纠纷仍建议以官方渠道与法律意见为准。',
  },
  {
    id: 'auto',
    name: '汽车曝光',
    short: '汽车',
    icon: 'ri-roadster-line',
    tagline: '质量问题 · 用车体验',
    desc: '车主反馈、召回通报与新车配置信息的整理。',
    intro:
      '汽车分区汇总车主真实反馈与公开的质量通报，按车型和问题类型归类。买车前想了解某一款车的长期口碑，或者想对照同价位配置差异，都可以从这里入手，再结合线下试驾做决定。',
  },
  {
    id: 'house',
    name: '房产观察',
    short: '房产',
    icon: 'ri-building-2-line',
    tagline: '楼市动态 · 交易参考',
    desc: '政策公示、楼盘反馈与购房流程要点的整理。',
    intro:
      '房产分区关注政策公示、楼盘交付反馈与购房流程要点。我们尽量把零散的信息按城市与环节整理，方便你在做置业决策前有个整体概念。具体政策请以当地主管部门发布为准。',
  },
  {
    id: 'campus',
    name: '校园话题',
    short: '校园',
    icon: 'ri-graduation-cap-line',
    tagline: '校园动态 · 升学资讯',
    desc: '高校动态、招生政策与教育话题的公开汇总。',
    intro:
      '校园分区覆盖高校动态与升学相关信息。招生政策类内容以官方发布为优先来源，校园事件类内容坚持中立记录，只呈现公开可查的进展，避免给学生和家长带来误导。',
  },
  {
    id: 'career',
    name: '职场内幕',
    short: '职场',
    icon: 'ri-briefcase-line',
    tagline: '用工环境 · 薪酬参考',
    desc: '职场经验、薪酬区间与求职风险的整理。',
    intro:
      '职场分区整理了公开的薪酬区间参考、求职常见风险以及劳动法规要点。经验类内容来自匿名分享，仅代表分享者个人经历，建议作为参考而非结论，签约前务必仔细阅读合同条款。',
  },
  {
    id: 'health',
    name: '医健观察',
    short: '医健',
    icon: 'ri-heart-pulse-line',
    tagline: '就医经验 · 健康科普',
    desc: '就医流程经验、健康话题与用药提示的整理。',
    intro:
      '医健分区收录就医经验分享与公开的健康科普内容，目的在于帮你了解流程、少走弯路。所有内容都不能替代专业诊断，身体不适请及时就医并遵医嘱。',
  },
];

export const navSites: SiteItem[] = [
  {
    id: 'hot-1',
    name: '全网热搜榜',
    url: 'https://www.quanwang-resou.com',
    category: 'hot',
    desc: '聚合多家平台的实时热榜，按统一口径排序，一分钟就能看清全网正在讨论什么。',
    tags: ['实时热榜', '聚合'],
    heat: 98.5,
    score: 4.9,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'hot-2',
    name: '热议风向标',
    url: 'https://www.reyi-fengxiang.com',
    category: 'hot',
    desc: '记录话题讨论量随时间的变化曲线，帮助判断一件事是刚升温还是已经在降温。',
    tags: ['舆情趋势', '数据'],
    heat: 92.3,
    score: 4.8,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'hot-3',
    name: '今日焦点站',
    url: 'https://www.jinri-jiaodian.com',
    category: 'hot',
    desc: '每天早晚各梳理一次焦点事件，只保留有公开信源的进展，减少刷屏噪音。',
    tags: ['日更', '焦点'],
    heat: 87.6,
    score: 4.7,
    hot: true,
    updated: '2026-09-08',
  },
  {
    id: 'hot-4',
    name: '舆情观察室',
    url: 'https://www.yuqing-guancha.com',
    category: 'hot',
    desc: '面向内容从业者的舆情复盘笔记，包含传播路径与关键节点的整理。',
    tags: ['复盘', '传播'],
    heat: 76.4,
    score: 4.6,
    hot: false,
    updated: '2026-09-06',
  },
  {
    id: 'hot-5',
    name: '事件脉络档案',
    url: 'https://www.shijian-mailuo.com',
    category: 'hot',
    desc: '把持续时间长的事件按时间线串起来，方便从头了解背景与起因。',
    tags: ['时间线', '归档'],
    heat: 63.2,
    score: 4.5,
    hot: false,
    updated: '2026-09-04',
  },
  {
    id: 'ent-1',
    name: '影视速报网',
    url: 'https://www.yingshi-subao.com',
    category: 'ent',
    desc: '剧集与电影的上线、定档、口碑变化集中整理，避免错过排播节点。',
    tags: ['影视', '定档'],
    heat: 88.1,
    score: 4.7,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'ent-2',
    name: '星闻观察站',
    url: 'https://www.xingwen-guancha.com',
    category: 'ent',
    desc: '只收录有公开来源的演艺动态，不做无凭据的推测与拼凑。',
    tags: ['演艺', '动态'],
    heat: 82.5,
    score: 4.6,
    hot: false,
    updated: '2026-09-07',
  },
  {
    id: 'ent-3',
    name: '综艺情报局',
    url: 'https://www.zongyi-qingbao.com',
    category: 'ent',
    desc: '综艺排播表、嘉宾阵容与播出后的公开反馈一站查看。',
    tags: ['综艺', '排播'],
    heat: 71.8,
    score: 4.5,
    hot: false,
    updated: '2026-09-05',
  },
  {
    id: 'ent-4',
    name: '幕后议题社',
    url: 'https://www.muhou-yiti.com',
    category: 'ent',
    desc: '讨论制作、发行与内容生态的行业观察栏目，适合作者与从业者阅读。',
    tags: ['行业', '制作'],
    heat: 58.9,
    score: 4.4,
    hot: false,
    updated: '2026-09-03',
  },
  {
    id: 'finance-1',
    name: '财报放大镜',
    url: 'https://www.caibao-fangda.com',
    category: 'finance',
    desc: '逐季拆解公开财报重点科目，附同比与环比对照，快速看清经营变化。',
    tags: ['财报', '数据'],
    heat: 84.7,
    score: 4.8,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'finance-2',
    name: '资本观察室',
    url: 'https://www.ziben-guancha.com',
    category: 'finance',
    desc: '整理并购、融资与股权变动的公开披露信息，标注信息来源与时间。',
    tags: ['融资', '并购'],
    heat: 79.3,
    score: 4.6,
    hot: false,
    updated: '2026-09-08',
  },
  {
    id: 'finance-3',
    name: '财讯快线',
    url: 'https://www.caixun-kuaixian.com',
    category: 'finance',
    desc: '交易时段内的公开资讯速览，按行业板块归类，方便纵向对比。',
    tags: ['快讯', '板块'],
    heat: 74.2,
    score: 4.5,
    hot: false,
    updated: '2026-09-07',
  },
  {
    id: 'finance-4',
    name: '上市公司内参',
    url: 'https://www.shangshi-neican.com',
    category: 'finance',
    desc: '公告要点摘录与前后文对照，尽量减少只看标题带来的误读。',
    tags: ['公告', '解读'],
    heat: 68.5,
    score: 4.4,
    hot: false,
    updated: '2026-09-05',
  },
  {
    id: 'finance-5',
    name: '理财避坑笔记',
    url: 'https://www.licai-bikeng.com',
    category: 'finance',
    desc: '汇总常见的理财宣传话术与风险提示，帮你分辨收益承诺背后的条件。',
    tags: ['理财', '风险'],
    heat: 61.4,
    score: 4.3,
    hot: false,
    updated: '2026-09-02',
  },
  {
    id: 'tech-1',
    name: '极客前线',
    url: 'https://www.jike-qianxian.com',
    category: 'tech',
    desc: '新品发布、系统更新与开发者动态的消息汇总，重要节点不会漏。',
    tags: ['数码', '发布'],
    heat: 80.6,
    score: 4.7,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'tech-2',
    name: '数码实测局',
    url: 'https://www.shuma-shiche.com',
    category: 'tech',
    desc: '收录公开的第三方实测数据，含续航、发热与性能跑分对照表。',
    tags: ['实测', '对比'],
    heat: 75.9,
    score: 4.6,
    hot: false,
    updated: '2026-09-08',
  },
  {
    id: 'tech-3',
    name: '科技风口站',
    url: 'https://www.keji-fengkou.com',
    category: 'tech',
    desc: '追踪新技术方向的公开进展与落地案例，标注时间与参与方。',
    tags: ['前沿', '落地'],
    heat: 70.3,
    score: 4.5,
    hot: false,
    updated: '2026-09-06',
  },
  {
    id: 'tech-4',
    name: '硬件吐槽站',
    url: 'https://www.yingjian-tucao.com',
    category: 'tech',
    desc: '收获集中反馈的硬件问题与厂商公开回应整理，按问题类型归类。',
    tags: ['反馈', '质量'],
    heat: 64.8,
    score: 4.4,
    hot: false,
    updated: '2026-09-04',
  },
  {
    id: 'rights-1',
    name: '投诉直通车',
    url: 'https://www.tousu-zhitongche.com',
    category: 'rights',
    desc: '按行业归类消费投诉案例，附处理结果参考，看得见的解决路径。',
    tags: ['投诉', '案例'],
    heat: 77.2,
    score: 4.7,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'rights-2',
    name: '消费避坑指南',
    url: 'https://www.xiaofei-bikeng.com',
    category: 'rights',
    desc: '整理常见营销套路与合同陷阱的识别要点，付款前对照一遍更安心。',
    tags: ['避坑', '套路'],
    heat: 72.6,
    score: 4.6,
    hot: false,
    updated: '2026-09-07',
  },
  {
    id: 'rights-3',
    name: '售后曝光台',
    url: 'https://www.shouhou-baoguang.com',
    category: 'rights',
    desc: '汇总公开的售后纠纷经过与协商进展，记录每次沟通的节点。',
    tags: ['售后', '纠纷'],
    heat: 66.1,
    score: 4.5,
    hot: false,
    updated: '2026-09-05',
  },
  {
    id: 'rights-4',
    name: '权益小百科',
    url: 'https://www.quanyi-xiaobaike.com',
    category: 'rights',
    desc: '用通俗语言解释退换货、举证与投诉流程，新手也能看懂。',
    tags: ['流程', '举证'],
    heat: 59.7,
    score: 4.4,
    hot: false,
    updated: '2026-09-01',
  },
  {
    id: 'auto-1',
    name: '车主吐槽站',
    url: 'https://www.chezhu-tucao.com',
    category: 'auto',
    desc: '真实车主反馈的质量、能耗与售后问题汇总，按车型归类查看。',
    tags: ['车主', '反馈'],
    heat: 79.8,
    score: 4.7,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'auto-2',
    name: '汽车质量观察',
    url: 'https://www.qiche-zhiliang.com',
    category: 'auto',
    desc: '按车型整理公开的召回与质量通报信息，附发文机构与日期。',
    tags: ['召回', '通报'],
    heat: 73.5,
    score: 4.6,
    hot: false,
    updated: '2026-09-07',
  },
  {
    id: 'auto-3',
    name: '新车速递',
    url: 'https://www.xinche-sudi.com',
    category: 'auto',
    desc: '上市信息、配置差异与实测数据的归纳，选车时对照更直观。',
    tags: ['新车', '配置'],
    heat: 68.2,
    score: 4.5,
    hot: false,
    updated: '2026-09-05',
  },
  {
    id: 'auto-4',
    name: '用车避坑社',
    url: 'https://www.yongche-bikeng.com',
    category: 'auto',
    desc: '保养、理赔与购车议价的经验分享，都是具体场景下的实用建议。',
    tags: ['用车', '经验'],
    heat: 61.9,
    score: 4.4,
    hot: false,
    updated: '2026-09-02',
  },
  {
    id: 'house-1',
    name: '楼市观察室',
    url: 'https://www.loushi-guancha.com',
    category: 'house',
    desc: '政策与成交数据的公开信息整理，附趋势图，适合快速建立整体印象。',
    tags: ['楼市', '政策'],
    heat: 74.9,
    score: 4.6,
    hot: true,
    updated: '2026-09-08',
  },
  {
    id: 'house-2',
    name: '楼盘真相站',
    url: 'https://www.loupan-zhenxiang.com',
    category: 'house',
    desc: '汇总交付、质量与配套兑现的公开反馈，按项目逐个记录。',
    tags: ['楼盘', '交付'],
    heat: 69.4,
    score: 4.5,
    hot: false,
    updated: '2026-09-06',
  },
  {
    id: 'house-3',
    name: '购房避坑指南',
    url: 'https://www.goufang-bikeng.com',
    category: 'house',
    desc: '合同条款、贷款流程与验房要点梳理，签字之前值得读一遍。',
    tags: ['购房', '合同'],
    heat: 64.7,
    score: 4.4,
    hot: false,
    updated: '2026-09-03',
  },
  {
    id: 'house-4',
    name: '城建动态网',
    url: 'https://www.chengjian-dongtai.com',
    category: 'house',
    desc: '规划公示与交通建设进展的归集，关注区域发展的读者常看。',
    tags: ['规划', '城建'],
    heat: 58.3,
    score: 4.3,
    hot: false,
    updated: '2026-09-01',
  },
  {
    id: 'campus-1',
    name: '校园情报局',
    url: 'https://www.xiaoyuan-qingbao.com',
    category: 'campus',
    desc: '高校动态、校园活动与政策变化的公开信息汇总，学生党友好。',
    tags: ['校园', '动态'],
    heat: 70.8,
    score: 4.6,
    hot: false,
    updated: '2026-09-08',
  },
  {
    id: 'campus-2',
    name: '升学规划站',
    url: 'https://www.shengxue-guihua.com',
    category: 'campus',
    desc: '招生政策与专业选择的参考资料整理，注明政策发布年份。',
    tags: ['升学', '招生'],
    heat: 66.5,
    score: 4.5,
    hot: false,
    updated: '2026-09-06',
  },
  {
    id: 'campus-3',
    name: '高校观察室',
    url: 'https://www.gaoxiao-guancha.com',
    category: 'campus',
    desc: '学科建设与校园事件的中立观察记录，只呈现公开可查的进展。',
    tags: ['高校', '观察'],
    heat: 61.2,
    score: 4.4,
    hot: false,
    updated: '2026-09-03',
  },
  {
    id: 'campus-4',
    name: '教育热议榜',
    url: 'https://www.jiaoyu-reyi.com',
    category: 'campus',
    desc: '家长与学生关注度较高的教育话题排行，按讨论量每周更新。',
    tags: ['教育', '话题'],
    heat: 57.6,
    score: 4.3,
    hot: false,
    updated: '2026-08-31',
  },
  {
    id: 'career-1',
    name: '职场爆料站',
    url: 'https://www.zhichang-baoliao.com',
    category: 'career',
    desc: '用工环境与企业文化的匿名经验汇总，按行业归类，供参考对照。',
    tags: ['职场', '经验'],
    heat: 76.3,
    score: 4.7,
    hot: true,
    updated: '2026-09-09',
  },
  {
    id: 'career-2',
    name: '薪酬观察室',
    url: 'https://www.xinchou-guancha.com',
    category: 'career',
    desc: '按城市与岗位整理的公开薪酬区间参考，标注样本来源与时间。',
    tags: ['薪酬', '岗位'],
    heat: 71.7,
    score: 4.6,
    hot: false,
    updated: '2026-09-07',
  },
  {
    id: 'career-3',
    name: '求职避坑指南',
    url: 'https://www.qiuzhi-bikeng.com',
    category: 'career',
    desc: '面试话术、offer 条款与试用期风险提示，入职前建议通读。',
    tags: ['求职', '风险'],
    heat: 65.4,
    score: 4.5,
    hot: false,
    updated: '2026-09-04',
  },
  {
    id: 'career-4',
    name: '用工环境观察',
    url: 'https://www.yonggong-guancha.com',
    category: 'career',
    desc: '劳动法规更新与典型案例整理，帮助理解自身权益边界。',
    tags: ['法规', '案例'],
    heat: 60.1,
    score: 4.4,
    hot: false,
    updated: '2026-09-02',
  },
  {
    id: 'career-5',
    name: '副业参考局',
    url: 'https://www.fuye-cankao.com',
    category: 'career',
    desc: '公开的副业模式与收入结构拆解，包含时间成本与门槛说明。',
    tags: ['副业', '模式'],
    heat: 54.8,
    score: 4.2,
    hot: false,
    updated: '2026-08-30',
  },
  {
    id: 'health-1',
    name: '就医经验站',
    url: 'https://www.jiuyi-jingyan.com',
    category: 'health',
    desc: '挂号、检查与随访流程的真实经验分享，减少第一次就医的手忙脚乱。',
    tags: ['就医', '经验'],
    heat: 69.6,
    score: 4.6,
    hot: true,
    updated: '2026-09-08',
  },
  {
    id: 'health-2',
    name: '健康观察室',
    url: 'https://www.jiankang-guancha.com',
    category: 'health',
    desc: '公共卫生信息与健康话题的公开整理，注明信息来源与发布时间。',
    tags: ['健康', '科普'],
    heat: 64.3,
    score: 4.5,
    hot: false,
    updated: '2026-09-06',
  },
  {
    id: 'health-3',
    name: '医患话题榜',
    url: 'https://www.yihuan-huati.com',
    category: 'health',
    desc: '关注度较高的医患话题与政策讨论归档，方便回顾发展脉络。',
    tags: ['医患', '话题'],
    heat: 59.2,
    score: 4.4,
    hot: false,
    updated: '2026-09-03',
  },
  {
    id: 'health-4',
    name: '用药避坑指南',
    url: 'https://www.yongyao-bikeng.com',
    category: 'health',
    desc: '常见用药误区与说明书重点摘录，提醒注意配伍与禁忌事项。',
    tags: ['用药', '安全'],
    heat: 55.7,
    score: 4.3,
    hot: false,
    updated: '2026-08-31',
  },
];

export const commonFaqs: FaqItem[] = [
  {
    q: '爆料导航网主要收录哪些类型的内容？',
    a: '我们按领域整理公开信息类站点，涵盖热点、娱乐、财经、科技、消费维权、汽车、房产、校园、职场与医健十个方向。所有分类都由编辑人工核对，只保留有公开信息源的站点，推测类、无来源的内容一律不收录。',
  },
  {
    q: '使用爆料导航需要注册或者付费吗？',
    a: '不需要。浏览分类与站点目录完全免费，也无需登录。只有当你希望把新的站点提交进目录时，才需要填写一份简短的收录申请表。',
  },
  {
    q: '网站目录里的信息多久更新一次？',
    a: '站点的热度与排序每日更新一次；被收录站点的基本信息每周复核一次。长期无法访问、或内容方向已经变化的站点，我们会从目录中移出。',
  },
  {
    q: '我自己的网站可以提交收录吗？',
    a: '可以。只要站点内容合规、能够稳定访问，并且属于我们已开设的分类方向，就可以通过收录提交页面申请。审核一般需要三到五个工作日。',
  },
  {
    q: '发现收录的信息有误该怎么办？',
    a: '欢迎通过关于我们页面里的联系方式反馈。核实之后我们会尽快更正，并在该条目的备注中同步更新说明。',
  },
  {
    q: '为什么同一个分类下的站点顺序会变化？',
    a: '排序综合参考公开热度、更新频率与用户反馈评分，因此会随实际情况浮动。我们不接受付费置顶，也不出售排序位置。',
  },
];